// extracted by mini-css-extract-plugin
module.exports = {"PinWheel":"pin-wheel_PinWheel__1Hvkw","rotate":"pin-wheel_rotate__ZgrZ4"};